import { skipToken, useQuery } from '@tanstack/react-query';
import { usePublishedContext } from '@/components/views/published/PublishedContext';
import type { EstimationScheme } from '@/lib/api/types/estimationScheme';
import { useGetEstimationSchemesQuery } from '@/lib/queries/common/useGetEstimationScheme';
import { commonQueryKeys } from '@/lib/query-keys/common';

export const useEstimationSchemesQueryWithPublished = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  const publishedContext = usePublishedContext();
  const isPublished = publishedContext !== null;

  const schemesQuery = useGetEstimationSchemesQuery({ enabled: !isPublished && enabled });

  const publishedQuery = useQuery<EstimationScheme[] | undefined>({
    queryKey: [...commonQueryKeys.estimationSchemes.all(), 'published'],
    queryFn: skipToken,
    initialData: () => publishedContext?.estimationSchemes,
    enabled: false,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  return isPublished ? publishedQuery : schemesQuery;
};
